/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: accountpb/address.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.accountpb = require('./address_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.AddressServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.AddressServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.Address,
 *   !proto.accountpb.CreateAddressResponse>}
 */
const methodDescriptor_AddressService_CreateAddress = new grpc.web.MethodDescriptor(
  '/accountpb.AddressService/CreateAddress',
  grpc.web.MethodType.UNARY,
  proto.accountpb.Address,
  proto.accountpb.CreateAddressResponse,
  /**
   * @param {!proto.accountpb.Address} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.CreateAddressResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.Address} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.CreateAddressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.CreateAddressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.AddressServiceClient.prototype.createAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.AddressService/CreateAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_CreateAddress,
      callback);
};


/**
 * @param {!proto.accountpb.Address} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.CreateAddressResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.AddressServicePromiseClient.prototype.createAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.AddressService/CreateAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_CreateAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.Address,
 *   !proto.accountpb.UpdateAddressResponse>}
 */
const methodDescriptor_AddressService_UpdateAddress = new grpc.web.MethodDescriptor(
  '/accountpb.AddressService/UpdateAddress',
  grpc.web.MethodType.UNARY,
  proto.accountpb.Address,
  proto.accountpb.UpdateAddressResponse,
  /**
   * @param {!proto.accountpb.Address} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.UpdateAddressResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.Address} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.UpdateAddressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.UpdateAddressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.AddressServiceClient.prototype.updateAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.AddressService/UpdateAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_UpdateAddress,
      callback);
};


/**
 * @param {!proto.accountpb.Address} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.UpdateAddressResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.AddressServicePromiseClient.prototype.updateAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.AddressService/UpdateAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_UpdateAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ReadAddressRequest,
 *   !proto.accountpb.ReadAddressResponse>}
 */
const methodDescriptor_AddressService_ReadAddress = new grpc.web.MethodDescriptor(
  '/accountpb.AddressService/ReadAddress',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ReadAddressRequest,
  proto.accountpb.ReadAddressResponse,
  /**
   * @param {!proto.accountpb.ReadAddressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadAddressResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ReadAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.ReadAddressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadAddressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.AddressServiceClient.prototype.readAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.AddressService/ReadAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_ReadAddress,
      callback);
};


/**
 * @param {!proto.accountpb.ReadAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadAddressResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.AddressServicePromiseClient.prototype.readAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.AddressService/ReadAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_ReadAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ReadFirstPrimaryAddressRequest,
 *   !proto.accountpb.ReadFirstPrimaryAddressResponse>}
 */
const methodDescriptor_AddressService_ReadFirstPrimaryAddress = new grpc.web.MethodDescriptor(
  '/accountpb.AddressService/ReadFirstPrimaryAddress',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ReadFirstPrimaryAddressRequest,
  proto.accountpb.ReadFirstPrimaryAddressResponse,
  /**
   * @param {!proto.accountpb.ReadFirstPrimaryAddressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ReadFirstPrimaryAddressResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ReadFirstPrimaryAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.ReadFirstPrimaryAddressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ReadFirstPrimaryAddressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.AddressServiceClient.prototype.readFirstPrimaryAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.AddressService/ReadFirstPrimaryAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_ReadFirstPrimaryAddress,
      callback);
};


/**
 * @param {!proto.accountpb.ReadFirstPrimaryAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ReadFirstPrimaryAddressResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.AddressServicePromiseClient.prototype.readFirstPrimaryAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.AddressService/ReadFirstPrimaryAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_ReadFirstPrimaryAddress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.DeleteAddressRequest,
 *   !proto.accountpb.DeleteAddressResponse>}
 */
const methodDescriptor_AddressService_DeleteAddress = new grpc.web.MethodDescriptor(
  '/accountpb.AddressService/DeleteAddress',
  grpc.web.MethodType.UNARY,
  proto.accountpb.DeleteAddressRequest,
  proto.accountpb.DeleteAddressResponse,
  /**
   * @param {!proto.accountpb.DeleteAddressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.DeleteAddressResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.DeleteAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.DeleteAddressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.DeleteAddressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.AddressServiceClient.prototype.deleteAddress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.AddressService/DeleteAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_DeleteAddress,
      callback);
};


/**
 * @param {!proto.accountpb.DeleteAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.DeleteAddressResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.AddressServicePromiseClient.prototype.deleteAddress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.AddressService/DeleteAddress',
      request,
      metadata || {},
      methodDescriptor_AddressService_DeleteAddress);
};


module.exports = proto.accountpb;

